import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { FlashcardStack } from './FlashcardStack';
import { useTranslation } from 'react-i18next';
import { FrontFlashcard } from './FrontFlashcard';
import { BackFlashcard } from './BackFlashcard';

type ReviewingFlashcardViewProps = {
  frontContent: string;
  backContent: string;
  showFrontOnBack: boolean;
};

export function ReviewingFlashcardView({
  frontContent,
  backContent,
  showFrontOnBack,
}: ReviewingFlashcardViewProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'questionView.flashcard',
  });

  return (
    <div className="w-full flex flex-col items-center justify-center gap-x-4 gap-y-6">
      <ConditionalRenderer condition={frontContent}>
        <div className="flex flex-col items-center justify-center gap-x-4 gap-y-6 ">
          <h3 className="text-sm font-semibold text-primary">{t('front')}</h3>
          <FlashcardStack
            front={<FrontFlashcard content={frontContent} />}
            flipPlaceholder={t('flipCard')}
          />
        </div>
      </ConditionalRenderer>
      <ConditionalRenderer
        condition={backContent || (frontContent && showFrontOnBack)}
      >
        <div className="flex flex-col items-center justify-center gap-x-4 gap-y-6 ">
          <h3 className="text-sm font-semibold text-primary">{t('back')}</h3>
          <FlashcardStack
            front={
              frontContent && showFrontOnBack ? (
                <FrontFlashcard content={frontContent} />
              ) : undefined
            }
            back={
              <BackFlashcard
                frontContent={frontContent}
                backContent={backContent}
                showFrontOnBack={showFrontOnBack}
              />
            }
            showBack
          />
        </div>
      </ConditionalRenderer>
    </div>
  );
}
